import { UIHeading1 } from '@cian/ui-kit';
import clsx from 'clsx';
import * as React from 'react';

import * as styles from './NewbuildingPriceInfo.css';

interface INewbuildingPriceInfoProps {
  price: string;
  priceHistory: React.ReactElement | null;
  discount?: React.ReactElement | null;
  purchaseTerms?: React.ReactElement | null;
  isCompactModeEnabled?: boolean;
  fullPricePayment?: React.ReactNode;
  isBookedFromDeveloper?: boolean;
}

export const NewbuildingPriceInfo = ({
  price,
  priceHistory,
  discount,
  isCompactModeEnabled,
  purchaseTerms,
  fullPricePayment,
  isBookedFromDeveloper,
}: INewbuildingPriceInfoProps) => {
  return (
    <div className={styles['price']}>
      {!isCompactModeEnabled && <div className={clsx(styles['discount'], styles['hide-if-empty'])}>{discount}</div>}
      <div data-testid="price-amount" className={styles['amount']}>
        <UIHeading1 color={isBookedFromDeveloper ? 'text-secondary-default' : undefined}>{price}</UIHeading1>
      </div>
      <div data-testid="price-history-button" className={styles['history']}>
        {priceHistory}
      </div>
      {isCompactModeEnabled && (
        <div className={clsx(styles['discount'], styles['inline'], styles['hide-if-empty'])}>{discount}</div>
      )}
      <div className={clsx(styles['purchase-terms'], styles['hide-if-empty'])}>{purchaseTerms}</div>
      <div className={clsx(styles['full-price-payment'], styles['hide-if-empty'])}>{fullPricePayment}</div>
    </div>
  );
};
